export const NAME = 'passwordReset'
export const PASSWORD_RESET_REQUEST = 'passwordResetRequest'



// WEBPACK FOOTER //
// ../source/views/PasswordReset/constants.js